import { render, staticRenderFns } from "./almaviva-wines.vue?vue&type=template&id=3f126982&scoped=true"
import script from "./almaviva-wines.vue?vue&type=script&lang=js"
export * from "./almaviva-wines.vue?vue&type=script&lang=js"
import style0 from "./almaviva-wines.vue?vue&type=style&index=0&id=3f126982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f126982",
  null
  
)

export default component.exports